import React from 'react';
import { useSelector } from 'react-redux';

import Text from 'components/Text';
import { Column } from 'components/Layout/Grid';
import SwitchComponent from 'components/SwitchComponent';
import TabNavigation from 'components/TabNavigation';
import { InternalUserTable } from './InternalUserTable';
import { ExternalUserTable } from './ExternalUserTable';

import { IUser } from 'models/User';

const EmployeeManager: React.FC = () => {
  const user = useSelector((state: { user: IUser; }) => state.user);
  
  const viveoTabConfig = {
    label: 'Usuários Viveo',
    filter: {},
    trackingName: 'Aba_UsuariosViveo'
  };
  const externalUserTabConfig = {
    label: 'Usuários Externo',
    filter: {},
    trackingName: 'Aba_UsuariosExterno'
  };
  const viveoTabContent = 
    <Column className="w-100 max-w-lg-100 flex-1" key={1}>
      <InternalUserTable
        currentTabId="Usuários Viveo"
      />
    </Column>;
  const externalUserTabContent = 
    <Column className="w-100 max-w-lg-100 flex-1" key={2}>
      <ExternalUserTable
        currentTabId="Usuários Externo"
      />
    </Column>;

  const tabConfigList = user?.userType == 'supplier'
    ? [ externalUserTabConfig ]
    : [ viveoTabConfig, externalUserTabConfig ];
  const tabContentList = user?.userType == 'supplier'
    ? [ externalUserTabContent ]
    : [ viveoTabContent, externalUserTabContent ];
  
  return (
    <SwitchComponent roles={['administrator']} type={['employee','supplier']} redirect="/">
      <Text className="color-primary font-bold" size={24}>
        Gerenciar Usuários
      </Text>

      <Column className="mt-3">
        <TabNavigation
          trackingKey="Abas CTEs"
          trackingEvent="CTEs"
          tabLabels={tabConfigList}
          pages={tabContentList}
        />
      </Column>
    </SwitchComponent >
  );
};

export default EmployeeManager;
